import { offcanvas } from "./_offcanvas";
import { table_responsive } from "./_table_responsive";

offcanvas();
table_responsive();
